import { Pattern1 } from "@/(front-desk)/utils/patterns"
import { useEffect, useState } from "react"
import Transition from "@/(front-desk)/components/Transition"
import classNames from "classnames"
import Badges from "@/(front-desk)/user/compete/(components)/Badges"
import DECover1 from "@/(front-desk)/assets/images/about/award/DE/cover-1.png"
import DECover2 from "@/(front-desk)/assets/images/about/award/DE/cover-2.png"
import DECover3 from "@/(front-desk)/assets/images/about/award/DE/cover-3.png"
import DECover4 from "@/(front-desk)/assets/images/about/award/DE/cover-4.png"
import DECover5 from "@/(front-desk)/assets/images/about/award/DE/cover-5.png"
import DECover6 from "@/(front-desk)/assets/images/about/award/DE/cover-6.png"
import DECover7 from "@/(front-desk)/assets/images/about/award/DE/cover-7.png"
import DECover8 from "@/(front-desk)/assets/images/about/award/DE/cover-8.png"
import DECover9 from "@/(front-desk)/assets/images/about/award/DE/cover-9.png"
import DECover10 from "@/(front-desk)/assets/images/about/award/DE/cover-10.png"
import ANCover1 from "@/(front-desk)/assets/images/about/award/AN/cover-1.png"
import ANCover2 from "@/(front-desk)/assets/images/about/award/AN/cover-2.png"
import ANCover3 from "@/(front-desk)/assets/images/about/award/AN/cover-3.png"
import ANCover4 from "@/(front-desk)/assets/images/about/award/AN/cover-4.png"
import ANCover5 from "@/(front-desk)/assets/images/about/award/AN/cover-5.png"
import ANCover6 from "@/(front-desk)/assets/images/about/award/AN/cover-6.png"
import ANCover7 from "@/(front-desk)/assets/images/about/award/AN/cover-7.png"
import ANCover8 from "@/(front-desk)/assets/images/about/award/AN/cover-8.png"
import ANCover9 from "@/(front-desk)/assets/images/about/award/AN/cover-9.png"
import ANCover10 from "@/(front-desk)/assets/images/about/award/AN/cover-10.png"
import ANCover11 from "@/(front-desk)/assets/images/about/award/AN/cover-11.png"
import ANCover12 from "@/(front-desk)/assets/images/about/award/AN/cover-12.png"
import ANCover13 from "@/(front-desk)/assets/images/about/award/AN/cover-13.png"
import ANCover14 from "@/(front-desk)/assets/images/about/award/AN/cover-14.png"
import ANCover15 from "@/(front-desk)/assets/images/about/award/AN/cover-15.png"
import ANCover16 from "@/(front-desk)/assets/images/about/award/AN/cover-16.png"
import GACover1 from "@/(front-desk)/assets/images/about/award/GA/cover-1.png"
import GACover2 from "@/(front-desk)/assets/images/about/award/GA/cover-2.png"
import GACover3 from "@/(front-desk)/assets/images/about/award/GA/cover-3.png"
import GACover4 from "@/(front-desk)/assets/images/about/award/GA/cover-4.png"
import GACover5 from "@/(front-desk)/assets/images/about/award/GA/cover-5.png"
import GACover6 from "@/(front-desk)/assets/images/about/award/GA/cover-6.png"
import GACover7 from "@/(front-desk)/assets/images/about/award/GA/cover-7.png"
import GACover8 from "@/(front-desk)/assets/images/about/award/GA/cover-8.png"
import GACover9 from "@/(front-desk)/assets/images/about/award/GA/cover-9.png"
import GACover10 from "@/(front-desk)/assets/images/about/award/GA/cover-10.png"
import GACover11 from "@/(front-desk)/assets/images/about/award/GA/cover-11.png"
import GACover12 from "@/(front-desk)/assets/images/about/award/GA/cover-12.png"
import GACover13 from "@/(front-desk)/assets/images/about/award/GA/cover-13.png"
import GACover14 from "@/(front-desk)/assets/images/about/award/GA/cover-14.png"
import GACover15 from "@/(front-desk)/assets/images/about/award/GA/cover-15.png"
import GACover16 from "@/(front-desk)/assets/images/about/award/GA/cover-16.png"
import GACover17 from "@/(front-desk)/assets/images/about/award/GA/cover-17.png"
import GACover18 from "@/(front-desk)/assets/images/about/award/GA/cover-18.png"
import INCover1 from "@/(front-desk)/assets/images/about/award/IN/cover-1.png"
import INCover2 from "@/(front-desk)/assets/images/about/award/IN/cover-2.png"
import INCover3 from "@/(front-desk)/assets/images/about/award/IN/cover-3.png"
import INCover4 from "@/(front-desk)/assets/images/about/award/IN/cover-4.png"
import INCover5 from "@/(front-desk)/assets/images/about/award/IN/cover-5.png"
import FICover1 from "@/(front-desk)/assets/images/about/award/FI/cover-1.png"
import FICover2 from "@/(front-desk)/assets/images/about/award/FI/cover-2.png"
import FICover3 from "@/(front-desk)/assets/images/about/award/FI/cover-3.png"
import FICover4 from "@/(front-desk)/assets/images/about/award/FI/cover-4.png"
import FICover5 from "@/(front-desk)/assets/images/about/award/FI/cover-5.png"

const categoryList = {
    DE_CO: '傳達設計組',
    DE_PR: '產品設計組',
    AN_2D: '2D 動畫組',
    AN_3D: '3D 動畫組',
    AN_EX: '實驗與混合媒材動畫組',
    GA_MO: '行動遊戲組',
    GA_AT: '非典型遊戲組',
    GA_PC: 'PC 與遊戲主機組',
    IN_IN: '跨域組',
    FI_FI: '影視組'
}
const badgesList = {
    gold: {
        award_type: {
            shortcut: 'gold',
            name: '金獎'
        }
    },
    silver: {
        award_type: {
            shortcut: 'silver',
            name: '銀獎'
        }
    },
    bronze: {
        award_type: {
            shortcut: 'bronze',
            name: '銅獎'
        }
    },
    selected: {
        award_type: {
            shortcut: 'selected',
            name: '優選'
        }
    },
    best_animation: {
        award_type: {
            shortcut: 'gold',
            name: '最佳動畫'
        }
    },
    best_story: {
        award_type: {
            shortcut: 'silver',
            name: '最佳故事'
        }
    },
    best_character_design: {
        award_type: {
            shortcut: 'silver',
            name: '最佳角色設計'
        }
    },
    best_art_design: {
        award_type: {
            shortcut: 'silver',
            name: '最佳美術設計'
        }
    },
    best_character_animation: {
        award_type: {
            shortcut: 'silver',
            name: '最佳角色動畫'
        }
    },
    best_effect: {
        award_type: {
            shortcut: 'silver',
            name: '最佳技術與特效'
        }
    }
}
const awardList = [
    {
        shortcut: 'DE',
        name: '設計類',
        projects: {
            2024: [
                {
                    subcategory: 'DE_CO',
                    title: '變當',
                    school: '國立臺灣藝術大學 - 視覺傳達設計系',
                    award: badgesList.gold,
                    cover: DECover1.src,
                },
                {
                    subcategory: 'DE_PR',
                    title: '重力雕塑實驗計畫',
                    school: '實踐大學 - 工業產品設計學系',
                    award: badgesList.gold,
                    cover: DECover2.src,
                },
                {
                    subcategory: 'DE_CO',
                    title: '百百山脊',
                    school: '嶺東科技大學 - 視覺傳達設計系',
                    award: badgesList.silver,
                    cover: DECover3.src,
                },
                {
                    subcategory: 'DE_PR',
                    title: '湍流-溯溪鞋模組',
                    school: '實踐大學 - 工業產品設計學系',
                    award: badgesList.silver,
                    cover: DECover4.src,
                },
                {
                    subcategory: 'DE_CO',
                    title: '蜜餞岩究室',
                    school: '南臺科技大學 - 視覺傳達設計系',
                    award: badgesList.bronze,
                    cover: DECover5.src,
                },
                {
                    subcategory: 'DE_PR',
                    title: '五金件重組系列燈具',
                    school: '實踐大學 - 工業產品設計學系',
                    award: badgesList.bronze,
                    cover: DECover6.src,
                },
                {
                    subcategory: 'DE_CO',
                    title: '臺灣聲音史',
                    school: '國立臺灣科技大學 - 視覺傳達設計系',
                    award: badgesList.selected,
                    cover: DECover7.src,
                },
                {
                    subcategory: 'DE_CO',
                    title: '十八層地毯 Oh No！是地獄',
                    school: '國立臺灣藝術大學 - 視覺傳達設計系',
                    award: badgesList.selected,
                    cover: DECover8.src,
                },
                {
                    subcategory: 'DE_PR',
                    title: '彩券慾望轉移計畫 - 投注單層疊結構',
                    school: '實踐大學 - 工業產品設計學系',
                    award: badgesList.selected,
                    cover: DECover9.src,
                },
                {
                    subcategory: 'DE_PR',
                    title: '自然正義',
                    school: '中國科技大學 - 視覺傳達設計系',
                    award: badgesList.selected,
                    cover: DECover10.src,
                },
            ]
        }
    },
    {
        shortcut: 'AN',
        name: '動畫類',
        projects: {
            2024: [
                {
                    subcategory: '',
                    title: '汐',
                    school: '國立屏東大學 - 視覺藝術學系',
                    award: badgesList.best_animation,
                    cover: ANCover1.src,
                },
                {
                    subcategory: 'AN_2D',
                    title: '汐',
                    school: '國立屏東大學 - 視覺藝術學系',
                    award: badgesList.best_story,
                    cover: ANCover2.src,
                },
                {
                    subcategory: 'AN_3D',
                    title: '瑕疵品',
                    school: '國立虎尾科技大學 - 多媒體設計系',
                    award: badgesList.best_story,
                    cover: ANCover3.src,
                },
                {
                    subcategory: 'AN_EX',
                    title: 'Rainbbit',
                    school: '南臺科技大學 - 視覺傳達設計系',
                    award: badgesList.best_story,
                    cover: ANCover4.src,
                },
                {
                    subcategory: 'AN_2D',
                    title: '汐',
                    school: '國立屏東大學 - 視覺藝術學系',
                    award: badgesList.best_character_design,
                    cover: ANCover5.src,
                },
                {
                    subcategory: 'AN_3D',
                    title: '七月三十二日',
                    school: '國立臺灣藝術大學 - 多媒體動畫藝術學系',
                    award: badgesList.best_character_design,
                    cover: ANCover6.src,
                },
                {
                    subcategory: 'AN_EX',
                    title: '花花公子妙世界',
                    school: '國立臺北藝術大學 - 動畫學系',
                    award: badgesList.best_character_design,
                    cover: ANCover7.src,
                },
                {
                    subcategory: 'AN_2D',
                    title: '迴程',
                    school: '國立臺灣藝術大學 - 多媒體動畫藝術學系',
                    award: badgesList.best_art_design,
                    cover: ANCover8.src,
                },
                {
                    subcategory: 'AN_3D',
                    title: '瑕疵品',
                    school: '國立虎尾科技大學 - 多媒體設計系',
                    award: badgesList.best_art_design,
                    cover: ANCover9.src,
                },
                {
                    subcategory: 'AN_EX',
                    title: 'Rainbbit',
                    school: '南臺科技大學 - 視覺傳達設計系',
                    award: badgesList.best_art_design,
                    cover: ANCover10.src,
                },
                {
                    subcategory: 'AN_2D',
                    title: '甜蜜迴圈',
                    school: '台南應用科技大學 - 多媒體動畫系',
                    award: badgesList.best_character_animation,
                    cover: ANCover11.src,
                },
                {
                    subcategory: 'AN_3D',
                    title: '迷糊的一天',
                    school: '國立臺北藝術大學 - 動畫學系',
                    award: badgesList.best_character_animation,
                    cover: ANCover12.src,
                },
                {
                    subcategory: 'AN_EX',
                    title: '花花公子妙世界',
                    school: '國立臺北藝術大學 - 動畫學系',
                    award: badgesList.best_character_animation,
                    cover: ANCover13.src,
                },
                {
                    subcategory: 'AN_2D',
                    title: '奧德賽快車',
                    school: '台南應用科技大學 - 多媒體動畫系',
                    award: badgesList.best_effect,
                    cover: ANCover14.src,
                },
                {
                    subcategory: 'AN_3D',
                    title: '瑕疵品',
                    school: '國立虎尾科技大學 - 多媒體設計系',
                    award: badgesList.best_effect,
                    cover: ANCover15.src,
                },
                {
                    subcategory: 'AN_EX',
                    title: '花花公子妙世界',
                    school: '國立臺北藝術大學 - 動畫學系',
                    award: badgesList.best_effect,
                    cover: ANCover16.src,
                },
            ]
        }
    },
    {
        shortcut: 'GA',
        name: '遊戲類',
        projects: {
            2024: [
                {
                    subcategory: 'GA_PC',
                    title: 'X-23 咕嚕',
                    school: '龍華科技大學 - 多媒體與遊戲發展科學系',
                    award: badgesList.gold,
                    cover: GACover1.src,
                },
                {
                    subcategory: 'GA_AT',
                    title: '黑暗喜劇',
                    school: '國立臺北科技大學 - 互動設計系',
                    award: badgesList.gold,
                    cover: GACover2.src,
                },
                {
                    subcategory: 'GA_PC',
                    title: '必殺球',
                    school: '國立雲林科技大學 - 機械工程系',
                    award: badgesList.silver,
                    cover: GACover3.src,
                },
                {
                    subcategory: 'GA_MO',
                    title: '靈魂整理師 - 娃娃的邀請',
                    school: '南臺科技大學 - 多媒體與電腦娛樂科學系',
                    award: badgesList.silver,
                    cover: GACover4.src,
                },
                {
                    subcategory: 'GA_MO',
                    title: '銬妖',
                    school: '正修科技大學 - 數位多媒體設計系',
                    award: badgesList.silver,
                    cover: GACover5.src,
                },
                {
                    subcategory: 'GA_AT',
                    title: 'Alchemyst',
                    school: '銘傳大學 - 數位媒體設計學系',
                    award: badgesList.silver,
                    cover: GACover6.src,
                },
                {
                    subcategory: 'GA_PC',
                    title: '時間到了！',
                    school: '世新大學 - 數位多媒體設計學系',
                    award: badgesList.bronze,
                    cover: GACover7.src,
                },
                {
                    subcategory: 'GA_PC',
                    title: '劇場奇譚',
                    school: '朝陽科技大學 - 資訊管理系',
                    award: badgesList.bronze,
                    cover: GACover8.src,
                },
                {
                    subcategory: 'GA_MO',
                    title: '你今晚有空嗎',
                    school: '實踐大學 - 媒體傳達設計學系',
                    award: badgesList.bronze,
                    cover: GACover9.src,
                },
                {
                    subcategory: 'GA_AT',
                    title: '凡星',
                    school: '國立臺北科技大學 - 互動設計系',
                    award: badgesList.bronze,
                    cover: GACover10.src,
                },
                {
                    subcategory: 'GA_PC',
                    title: '畫中世界',
                    school: '南臺科技大學 - 多媒體與電腦娛樂科學系',
                    award: badgesList.selected,
                    cover: GACover11.src,
                },
                {
                    subcategory: 'GA_PC',
                    title: '遠星點',
                    school: '南臺科技大學 - 多媒體與電腦娛樂科學系',
                    award: badgesList.selected,
                    cover: GACover12.src,
                },
                {
                    subcategory: 'GA_PC',
                    title: '真相編織',
                    school: '南臺科技大學 - 多媒體與電腦娛樂科學系',
                    award: badgesList.selected,
                    cover: GACover13.src,
                },
                {
                    subcategory: 'GA_PC',
                    title: '太空奧德賽',
                    school: '大同大學 - 媒體設計學系',
                    award: badgesList.selected,
                    cover: GACover14.src,
                },
                {
                    subcategory: 'GA_PC',
                    title: 'AERIAL風靈',
                    school: '國國立虎尾科技大學 - 多媒體設計系',
                    award: badgesList.selected,
                    cover: GACover15.src,
                },
                {
                    subcategory: 'GA_PC',
                    title: '異世界外送員',
                    school: '世新大學 - 數位多媒體設計學系',
                    award: badgesList.selected,
                    cover: GACover16.src,
                },
                {
                    subcategory: 'GA_PC',
                    title: '喀拉喀拉',
                    school: '南臺科技大學 - 多媒體與電腦娛樂科學系',
                    award: badgesList.selected,
                    cover: GACover17.src,
                },
                {
                    subcategory: 'GA_MO',
                    title: '溯',
                    school: '嶺東科技大學 - 數位媒體設計系',
                    award: badgesList.selected,
                    cover: GACover18.src,
                },
            ]
        }
    },
    {
        shortcut: 'IN',
        name: '跨域類',
        projects: {
            2024: [
                {
                    subcategory: '',
                    title: '陳水宏',
                    school: '崑山科技大學 - 視覺傳達設計系',
                    award: badgesList.gold,
                    cover: INCover1.src,
                },
                {
                    subcategory: '',
                    title: 'Blinking Bullet',
                    school: '國立臺北科技大學 - 互動設計系',
                    award: badgesList.silver,
                    cover: INCover2.src,
                },
                {
                    subcategory: '',
                    title: '天使的翅膀',
                    school: '醒吾科技大學 - 商業設計系',
                    award: badgesList.bronze,
                    cover: INCover3.src,
                },
                {
                    subcategory: '',
                    title: '賄賂空間設計有限公司',
                    school: '元智大學 - 資訊傳播學系',
                    award: badgesList.selected,
                    cover: INCover4.src,
                },
                {
                    subcategory: '',
                    title: '翩翩',
                    school: '元智大學 - 資訊傳播學系',
                    award: badgesList.selected,
                    cover: INCover5.src,
                },
            ]
        }
    },
    {
        shortcut: 'FI',
        name: '影視類',
        projects: {
            2024: [
                {
                    subcategory: '',
                    title: '喊聲！足球少年！',
                    school: '元智大學 - 資訊傳播學系',
                    award: badgesList.gold,
                    cover: FICover1.src,
                },
                {
                    subcategory: '',
                    title: '甘榜男孩',
                    school: '義守大學 - 電影與電視學系',
                    award: badgesList.silver,
                    cover: FICover2.src,
                },
                {
                    subcategory: '',
                    title: '深層壓迫',
                    school: '世新大學 - 廣播電視電影學系',
                    award: badgesList.bronze,
                    cover: FICover3.src,
                },
                {
                    subcategory: '',
                    title: '謝相伴',
                    school: '南臺科技大學 - 資訊傳播系',
                    award: badgesList.selected,
                    cover: FICover4.src,
                },
                {
                    subcategory: '',
                    title: '番茄鯖魚麵',
                    school: '國立臺灣藝術大學 - 廣播電視學系',
                    award: badgesList.selected,
                    cover: FICover5.src,
                },
            ]
        }
    }
]

const Project = (props) => {

    const { active, info } = props
    const [ loaded, setLoaded ] = useState(false)

    useEffect(() => {
        const img = new Image()
        img.onload = () => setLoaded(true)
        img.src = info.cover
    }, [])

    return (
        <div className={classNames('flex flex-col gap-3', {
            'animate-pulse': !loaded
        })}>
            {/* <div className="text-[1.125rem] text-black-700 font-semibold">
                {active.name} {info.subcategory ? '-' : ''} {categoryList[info.subcategory]}
            </div> */}
            <div className="relative rounded-[0.75rem] overflow-hidden">
                <div className="w-full min-h-[13.5rem] bg-black-800">
                    <img
                        className={classNames('full object-cover transition', {
                            'opacity-0': !loaded
                        })}
                        src={info.cover}
                    />
                </div>
                <div className="absolute flex flex-col justify-between w-full h-full top-0 left-0 p-4 bg-gradient-to-b from-[transparent] from-30% to-[rgba(0,0,0,0.9)]">
                    <Badges awards={[info.award]} />
                    <div className="flex flex-col gap-2">
                        <div className="text-[1.5rem] text-white font-semibold">{info.title}</div>
                        <div className="text-[0.75rem] text-white font-light">{info.school}</div>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default function Award() {
    
    const [ active, setActive ] = useState(awardList[0])

    const groupBySubcategory = (projects, year) => {
        return projects[year].reduce((acc, cur) => (
            (acc[cur.subcategory] = acc[cur.subcategory] || []).push(cur), acc
        ), {})
    }

    return (
        <div className="history flex flex-col gap-[3rem]">
            {/* <div className="flex flex-col md:flex-row items-start md:items-center gap-[2.25rem]"> */}
            <div className="flex flex-col md:flex-row items-start gap-[2.25rem]">
                <div className="text-[1.875rem] text-white font-semibold whitespace-nowrap">歷年獲獎作品</div>
                {/* <div className="w-full md:w-[calc(100%-10rem)] overflow-x-scroll overflow-y-hidden"> */}
                    {/* <div className="flex gap-4"> */}
                    <div className="flex flex-wrap sm:!gap-4 gap-3">
                        { awardList.map((award) => (
                            <button
                                key={`award-${award.shortcut}`}
                                className={classNames('btn-round whitespace-nowrap', {
                                    'btn-main': award.shortcut === active.shortcut,
                                    'btn-main-700': award.shortcut !== active.shortcut
                                })}
                                onClick={() => setActive(award)}
                            >{award.name}</button>
                        ))}
                    </div>
                {/* </div> */}
            </div>
            <Transition className="min-h-[30rem]" transitionKey={active.shortcut}>
                { Object.keys(active.projects).map((year) => (
                    // console.log(active.projects[year]),
                    <div key={`${active.projects}-${year}`} className="flex gap-[1.87rem] w-full">
                        <div className="flex-center flex-col gap-3 px-[1.2rem] !hidden md:!flex">
                            <Pattern1 className="w-[1.5rem] fill-black-600" />
                            <div className="text-[0.75rem] text-black-600 font-light">{year}</div>
                            <div className="h-full border-s border-[0.5px] border-black-600 w-fit"></div>
                        </div>
                        <div className="w-full flex flex-col gap-12">
                            {/* {active.projects[year].map((project, index) => (
                                // console.log(project),
                                <Project
                                    key={`${active.projects}-${year}-${index}`}
                                    active={active}
                                    info={project} 
                                />
                            ))} */}
                            { Object.keys(groupBySubcategory(active.projects, year)).map((subcategory) => (
                                // console.log(subcategory),
                                <div key={`${year}-${subcategory}`} className="flex flex-col gap-6">
                                    <div className="text-[1.125rem] text-black-700 font-semibold">
                                        {active.name} {subcategory ? '-' : ''} {categoryList[subcategory]}
                                    </div>
                                    <div className="w-full grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 grid-flow-row gap-8">
                                        { groupBySubcategory(active.projects, year)[subcategory].map((project, index) => (
                                            <Project
                                                key={`${active.projects}-${year}-${index}`}
                                                active={active}
                                                info={project} 
                                            />
                                        ))}
                                    </div>
                                </div>
                            ))}
                        </div>
                    </div>
                ))}
            </Transition>
            {/* <button
                className="btn-main-700 btn-round"
                onClick={() => {}}
            >載入更多年份</button> */}
        </div>
    )
}